import { Types } from './types'
const initialState = {
    dataOrder: {
        rows: [],
        paging: {}
    },
    dataVoucher: {
        rows: [],
        paging: {}
    },
    dataUserVoucher: {
        rows: [],
        paging: {}
    }
}

const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_ORDER:
            return {
                ...newState,
                dataOrder: action.payload
            }
        case Types.SAVE_LIST_VOUCHER:
            return {
                ...newState,
                dataVoucher: action.payload
            }        
        case Types.SAVE_LIST_USER_VOUCHER:
            return {
                ...newState,
                dataUserVoucher: action.payload
            }
        default: 
            return newState
    }
}

export default reducer